(function (configuration, $, ga) {


    if(!configuration || !configuration.enabled) {
        return;
    }

    if(!configuration.publicKey) {
        console.error("Push notification enabled but key not configured.")
        return;
    }

    var WEB_PUSH_ID = "web.cl.icasas";

    var ANALYTICS_CATEGORY = "web_push_notifications";
    var ANALYTICS_EVENT = "permission";




    function track(category, event, label) {
        ga('send', 'event', category, event, label);
        ga('global.send', 'event', category, event, label);
    }


    var wpAnalytics = {
        trackAskPermissions: function () {
            return Promise.resolve(track(ANALYTICS_CATEGORY, ANALYTICS_EVENT, "ask"));
        },
        trackPermissionsGranted: function () {
            return Promise.resolve(track(ANALYTICS_CATEGORY, ANALYTICS_EVENT, "granted"));
        },
        trackPermissionsDenied: function () {
            return Promise.resolve(track(ANALYTICS_CATEGORY, ANALYTICS_EVENT, "denied"));
        },
        trackPermissionsClosed: function () {
            return Promise.resolve(track(ANALYTICS_CATEGORY, ANALYTICS_EVENT, "closed"));
        }
    }

    var safariManager = {
        ifNeverAsked: function () {
            var permissionData = window.safari.pushNotification.permission(WEB_PUSH_ID);

            return (permissionData.permission === "default") ?
                Promise.resolve() :
                Promise.reject();
        },
        askPermission: function () {
            return new Promise(function (resolve, reject) {
                window.safari.pushNotification.requestPermission("https://m", WEB_PUSH_ID, {}, function (result) {
                    wpAnalytics.trackAskPermissions();
                    resolve(result);
                });
            });
        },
        ifGranted: function () {
            var permissionData = window.safari.pushNotification.permission(WEB_PUSH_ID);
            console.log(permissionData);
            return permissionData.permission !== "granted" ?
                Promise.reject() :
                Promise.resolve();
        }
    }

    var manager = {
        ifNeverAsked: function (registration) {
            if (Notification.permission === "denied") {
                return Promise.reject();
            }
            return registration.pushManager
                .getSubscription()
                .then(function (subscription) {
                    return (!subscription) ?
                        Promise.resolve() :
                        Promise.reject();
                })

        },
        askPermission: function () {
            return new Promise(function (resolve, reject) {
                const permissionResult = Notification.requestPermission(resolve);
                wpAnalytics.trackAskPermissions();

                if (permissionResult) {
                    permissionResult.then(resolve, reject);
                }
            })
        },
        ifGranted: function () {
            return Notification.permission !== "granted" ?
                Promise.reject(Notification.permission) :
                Promise.resolve();
        }
    }


    initPushNotification();
    $('.create-alert-visitor').click(initPushNotification);


    function initPushNotification() {
        if (!("serviceWorker" in navigator)) {
            return;
        }

        if (!("PushManager" in window)) {
            if (!("safari" in window && "pushNotification" in window.safari)) {
                return;
            }
            manager = safariManager;
        }

        navigator.serviceWorker
            .register("/www/resem/new_design/common/js/push/resemsw.js")
           // .then(manager.ifNeverAsked)
            .then(manager.askPermission)
            .then(manager.ifGranted)
            .then(subscribeUserToPush)
            .then(postSubscriptionToServer)
            .catch(function (reason) {
                if ("denied" === reason) {
                    wpAnalytics.trackPermissionsDenied();
                } else if ("default" === reason) {
                    wpAnalytics.trackPermissionsClosed();
                }
            });
    }


    function subscribeUserToPush() {
        wpAnalytics.trackPermissionsGranted();
        return navigator.serviceWorker.register('/www/resem/new_design/common/js/push/resemsw.js')
            .then(function (registration) {
                const subscribeOptions = {
                    userVisibleOnly: true,
                    applicationServerKey: configuration.publicKey,
                };
                return registration.pushManager.subscribe(subscribeOptions);
            });
    }

    function postSubscriptionToServer(subscription) {
        return fetch('/api/webpush/subscribe', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(subscription)
        });
    }
})(window.pushNotificationsConfig , $, ga);